import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPictureInPicture = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 9.333h-8c-0.733 0-1.333 0.6-1.333 1.333v5.333c0 0.733 0.6 1.333 1.333 1.333h8c0.733 0 1.333-0.6 1.333-1.333v-5.333c0-0.733-0.6-1.333-1.333-1.333zM28 4h-24c-1.467 0-2.667 1.2-2.667 2.667v18.667c0 1.467 1.2 2.64 2.667 2.64h24c1.467 0 2.667-1.173 2.667-2.64v-18.667c0-1.467-1.2-2.667-2.667-2.667zM26.667 25.347h-21.333c-0.733 0-1.333-0.6-1.333-1.333v-16.040c0-0.733 0.6-1.333 1.333-1.333h21.333c0.733 0 1.333 0.6 1.333 1.333v16.040c0 0.733-0.6 1.333-1.333 1.333z" })
});
export default SvgPictureInPicture;
